import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect, useRef } from 'react';
import { dataTestAttributes } from '../../dataTestAttributes';
import { CouponContainer, FormWrapper, StyledCheckmarkIcon, TextFieldWrapper, StyledSecondaryButton, StyledCouponButton, StyledTermsButton } from './styled';
import { TextInput } from '../../modules/TextInput';
import { Components } from '../../../../common/interfaces';
import { SpecType } from '../../../../utils/RioUtils/interfaces';
import { sendRioEvent } from '../../../../utils/RioUtils/rioHelper';
import { getErrorMessage } from '../../../../utils/ErrorUtil';
import { parseValueIntoString } from '../../../../utils/StringUtils';
import { SubType, LinkText, SuccessText, ElementType } from '../../../../utils/RioUtils/interfaces';
import { addCouponToCart, doAddCouponErrorLogging, getSuccessMessage, getCouponError, getCouponValidationText } from './helper';
import { Strings } from '../../strings';
import { Component, DropInPaymentsCommandNames, StatusTypes } from '../../../../utils/CallbackUtils/constants';
import { fireStatusUpdate } from '../../../../utils/CallbackUtils/index';
import { colors } from '@chegg-ui/theme';
import { useCouponCodeTerms as useCouponCodeResponse } from './../../../../hooks/useCouponCodeTerms';
import { Link } from '@chegg-ui/link';
var App = function App(_ref) {
  var _couponCodeResponse$d;
  var couponCode = _ref.couponCode,
    content = _ref.content,
    addCoupon = _ref.addCoupon,
    removeCoupon = _ref.removeCoupon,
    onRioEventFired = _ref.onRioEventFired,
    onError = _ref.onError,
    isCouponValidated = _ref.isCouponValidated,
    addCouponStatus = _ref.addCouponStatus,
    removeCouponStatus = _ref.removeCouponStatus,
    namespace = _ref.namespace,
    rioCouponDetails = _ref.rioCouponDetails,
    totalWithCurrencyFormat = _ref.totalWithCurrencyFormat,
    isRecurly = _ref.isRecurly;
  if (!content) return null;
  var buttonText = content.buttonText,
    labelText = content.labelText,
    placeholderText = content.placeholderText,
    addCouponText = content.addCouponText,
    removeCouponText = content.removeCouponText,
    termsCtaText = content.termsCtaText,
    successText = content.successText,
    termsLabelText = content.termsLabelText,
    noCodeText = content.noCodeText,
    invalidCouponText = content.invalidCouponText,
    couponSuccessText = content.couponSuccessText,
    couponAutoFillSuccessText = content.couponAutoFillSuccessText,
    couponRemovedText = content.couponRemovedText;
  if (!(buttonText && labelText && placeholderText && addCouponText && removeCouponText && termsCtaText && successText && termsLabelText)) {
    onError(getErrorMessage(Components.COUPON, Strings.MISSING_CONTENT_ERROR));
    return null;
  }
  var _useState = useState(couponCode !== undefined),
    _useState2 = _slicedToArray(_useState, 2),
    hideGotCouponButton = _useState2[0],
    setHideGotCouponButton = _useState2[1];
  var _useState3 = useState(couponCode || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    couponCodeValue = _useState4[0],
    setCouponCodeValue = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    inlineError = _useState6[0],
    setInlineError = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isReadonly = _useState8[0],
    setReadonly = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isLoading = _useState10[0],
    setLoading = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    couponApplied = _useState12[0],
    setCouponApplied = _useState12[1];
  var _useState13 = useState(),
    _useState14 = _slicedToArray(_useState13, 2),
    couponDetails = _useState14[0],
    setCouponDetails = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    couponMessage = _useState16[0],
    setCouponMessage = _useState16[1];
  var inputEl = useRef(null);
  var focusInput = function focusInput() {
    var _inputEl$current;
    return (_inputEl$current = inputEl.current) === null || _inputEl$current === void 0 ? void 0 : _inputEl$current.focus();
  };
  var couponCodeResponse = useCouponCodeResponse({
    couponCode: addCouponStatus === 'SUCCESS' && isRecurly ? couponCodeValue : ''
  });
  useEffect(function () {
    // if couponCode is passed in, apply the coupon to the cart and validate if necessary
    if (couponCodeValue) {
      isCouponValidated ? setSuccessState() : addCouponClickHandler();
    }
  }, []);
  useEffect(function () {
    if (addCouponStatus === 'ERROR') {
      setInvalidState();
    } else if (addCouponStatus === 'SUCCESS') {
      setSuccessState();
    }
  }, [addCouponStatus]);
  useEffect(function () {
    if (removeCouponStatus === 'SUCCESS') {
      setRemoveSuccessState();
      clearCouponField();
    }
  }, [removeCouponStatus]);
  useEffect(function () {
    if (hideGotCouponButton) {
      focusInput();
    }
  }, [hideGotCouponButton]);
  useEffect(function () {
    if (!couponApplied) {
      focusInput();
    }
  }, [couponApplied]);
  useEffect(function () {
    couponDetails && sendRioEvent({
      info: SuccessText.COUPON_SUCCESSFUL,
      specType: SpecType.SUCCESS,
      callback: onRioEventFired,
      namespace: namespace,
      coupon_details: couponDetails
    });
  }, [couponDetails]);

  /* TODO part of DCO NextJS iteration.
  // - uncomment this and address other TODO statements within
  // - add some tests
   useEffect(() => {
    if (responseData) {
      // TODO errorMessage can also come back in responseData.  How can we use this? or should we?
      const { success, isNonApplicableCoupon } = responseData;
      // set the state of the coupon component based on Response states
      if (success) {
        setSuccessState();
      } else if (isNonApplicableCoupon) {
        setNotApplicableState();
      } else {
        setInvalidState();
      }
      // TODO how does sibc behave when unable to remove a coupon?
    }
  }, [responseData]);
  */

  // hide text button and show the coupon field view
  var gotCouponClickHandler = function gotCouponClickHandler() {
    setHideGotCouponButton(true);
    // Rio logging: Get Coupon click
    sendRioEvent({
      info: LinkText.COUPON_CTA_CLICKED,
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.BUTTON,
      callback: onRioEventFired,
      namespace: namespace
    });
    // Rio Logging: Inputting into coupon field
    sendRioEvent({
      info: LinkText.COUPON_ENTERED,
      specType: SpecType.INTERACTION,
      subType: SubType.TEXT,
      elementType: ElementType.TEXT,
      callback: onRioEventFired,
      namespace: namespace
    });
  };
  var setSuccessState = function setSuccessState() {
    setCouponDetails(rioCouponDetails);
    var couponMessage = parseValueIntoString(getSuccessMessage(false, {
      couponSuccessText: couponSuccessText,
      couponAutoFillSuccessText: couponAutoFillSuccessText
    }), totalWithCurrencyFormat, '${price}');
    setLoading(false);
    setReadonly(true);
    setCouponApplied(true);
    setInlineError('');
    setCouponMessage(couponMessage);
    fireStatusUpdate([{
      status: StatusTypes.SUCCESS,
      command: DropInPaymentsCommandNames.ADD_COUPON,
      payload: {
        component: Component.COUPON,
        data: {
          message: couponMessage
        }
      }
    }], 'COUPON');
  };
  var handleErrorState = function handleErrorState(isNotApplicable) {
    var invalidError = getCouponValidationText('invalid', invalidCouponText);
    setLoading(false);
    setReadonly(false);
    setCouponApplied(false);
    setInlineError(invalidError);
    sendRioEvent({
      info: getCouponError(isNotApplicable),
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.BUTTON,
      callback: onRioEventFired,
      namespace: namespace
    });
    doAddCouponErrorLogging();
  };
  var setInvalidState = function setInvalidState() {
    handleErrorState(false);
  };
  var setRemoveSuccessState = function setRemoveSuccessState() {
    fireStatusUpdate([{
      status: StatusTypes.SUCCESS,
      payload: {
        component: Component.COUPON,
        data: {
          message: parseValueIntoString(couponRemovedText || Strings.COUPON_REMOVED, totalWithCurrencyFormat, '${price}')
        }
      }
    }], 'COUPON');
  };
  var couponCodeOnChange = function couponCodeOnChange(value) {
    setCouponCodeValue(value);
  };
  var addCouponClickHandler = function addCouponClickHandler() {
    // Rio Logging: Apply Coupon clicked
    sendRioEvent({
      info: LinkText.COUPON_APPLIED,
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.BUTTON,
      callback: onRioEventFired,
      namespace: namespace
    });

    /* ignoring this condition, since this is covered by the test,
       "prevents user from applying an empty coupon", but is still
       getting reported as uncovered in jest coverage  */
    /* istanbul ignore next */
    if (couponCodeValue.trim() === '') {
      var requiredError = getCouponValidationText('required', noCodeText);
      setInlineError(requiredError);
      return;
    }
    setLoading(true);
    addCouponToCart(couponCodeValue, addCoupon);
  };
  var clearCouponField = function clearCouponField() {
    // istanbul ignore next
    if (!isLoading) {
      removeCoupon(couponCodeValue);
      setCouponApplied(false);
      setCouponCodeValue('');
      setInlineError('');
      setReadonly(false);
      focusInput();
      setCouponMessage(parseValueIntoString(couponRemovedText || Strings.COUPON_REMOVED, totalWithCurrencyFormat, '${price}'));
    }
  };
  var removeCouponClickHandler = function removeCouponClickHandler() {
    clearCouponField();
    sendRioEvent({
      info: LinkText.COUPON_REMOVED,
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.BUTTON,
      callback: onRioEventFired,
      namespace: namespace
    });
  };
  var applyRemoveBtnOnClick = function applyRemoveBtnOnClick() {
    // move focus to input field so button is not highlighted and
    // then call appropriate method
    focusInput();
    couponApplied ? removeCouponClickHandler() : addCouponClickHandler();
  };
  var couponCampaignName = (_couponCodeResponse$d = couponCodeResponse.data) === null || _couponCodeResponse$d === void 0 || (_couponCodeResponse$d = _couponCodeResponse$d.subscriptionCoupon) === null || _couponCodeResponse$d === void 0 ? void 0 : _couponCodeResponse$d.name;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CouponContainer, null, !hideGotCouponButton ? /*#__PURE__*/React.createElement(StyledSecondaryButton, {
    size: 'small',
    "data-test": dataTestAttributes.GOT_COUPON_BUTTON,
    onClick: gotCouponClickHandler
  }, buttonText) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormWrapper, null, /*#__PURE__*/React.createElement(TextFieldWrapper, {
    error: inlineError
  }, /*#__PURE__*/React.createElement(TextInput, {
    "data-test": dataTestAttributes.COUPON_CODE_INPUT,
    id: 'coupon_code_input',
    ref: inputEl,
    labelText: labelText,
    value: couponCodeValue,
    onChange: function onChange(value) {
      return couponCodeOnChange(value);
    },
    placeholder: placeholderText,
    readOnly: isReadonly,
    errorText: inlineError,
    helperText: couponApplied ? successText : undefined
  }), couponApplied && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledCheckmarkIcon, {
    "data-test": dataTestAttributes.CHECKMARK_ICON,
    size: 'medium',
    svgColor: colors.teal,
    role: 'img',
    "aria-label": 'CheckMark Icon'
  })), couponMessage && /*#__PURE__*/React.createElement("div", {
    "data-test": dataTestAttributes.SR_COUPON_MESSAGE,
    className: 'sr-coupon-message',
    role: 'alert'
  }, couponMessage)), /*#__PURE__*/React.createElement(StyledCouponButton, {
    size: 'small',
    "data-test": couponApplied ? dataTestAttributes.REMOVE_COUPON_BUTTON : dataTestAttributes.ADD_COUPON_BUTTON,
    onClick: applyRemoveBtnOnClick,
    isLoading: isLoading
  }, couponApplied ? removeCouponText : addCouponText)), couponApplied && couponCampaignName && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTermsButton, {
    "data-test": dataTestAttributes.COUPON_TERMS_CTA
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/coupontnc/".concat(couponCampaignName),
    target: "_blank",
    "data-test": dataTestAttributes.COUPON_TERMS_URL
  }, termsCtaText))))));
};
export default /*#__PURE__*/React.memo(App);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/Coupon/views/App/index.js
// module id = 3504
// module chunks = 11